import React from 'react';

import FinalizedMessage from 'assembly/tabs/primer-assembly/FinalizedMessage';
import AssemblyErrorsWarnings from 'assembly/views/AssemblyErrorsWarnings';
import {ASSEMBLY_TYPE, Fragment} from 'constants/AssemblyConstants';

export interface StickyEndsRowProps {
  bases: string;
  downstreamFragment: Fragment;
  onClickDownstream: () => void;
  onClickUpstream: () => void;
  revcomp: string;
  showPrintableSummary: boolean;
  upstreamFragment: Fragment;
}

export function StickyEndRow({
  bases,
  downstreamFragment,
  onClickDownstream,
  onClickUpstream,
  revcomp,
  showPrintableSummary,
  upstreamFragment,
}: StickyEndsRowProps): JSX.Element {
  return (
    <tr>
      <td
        style={{[showPrintableSummary ? 'borderLeftColor' : 'backgroundColor']: upstreamFragment.color}}
        className="printable-color"
      >
        <a onClick={onClickUpstream}>{upstreamFragment.name}</a>
      </td>
      <td
        style={{[showPrintableSummary ? 'borderLeftColor' : 'backgroundColor']: downstreamFragment.color}}
        className="printable-color"
      >
        <a onClick={onClickDownstream}>{downstreamFragment.name}</a>
      </td>
      <td>{bases || <span className="faded">N/A</span>}</td>
      <td>{revcomp || <span className="faded">N/A</span>}</td>
    </tr>
  );
}

export interface StickyEndsProps {
  errors: Array<string>;
  finalized: boolean;
  rows: Array<StickyEndsRowProps>;
  warnings: Array<string>;
}

export default function StickyEnds({errors, finalized, rows, warnings}: StickyEndsProps): JSX.Element {
  return (
    <fieldset>
      <legend>Sticky Ends</legend>
      <div className="row">
        <div className="col col-md-12">
          <table className="table table-condensed table-hover">
            <thead>
              <tr>
                <th>Upstream</th>
                <th>Downstream</th>
                <th>
                  Bases
                  {finalized && <FinalizedMessage />}
                </th>
                <th>Reverse Complement</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(
                (
                  {
                    bases,
                    downstreamFragment,
                    revcomp,
                    onClickDownstream,
                    onClickUpstream,
                    showPrintableSummary,
                    upstreamFragment,
                  },
                  i
                ) => (
                  <StickyEndRow
                    key={i}
                    bases={bases}
                    downstreamFragment={downstreamFragment}
                    onClickDownstream={onClickDownstream}
                    onClickUpstream={onClickUpstream}
                    revcomp={revcomp}
                    showPrintableSummary={showPrintableSummary}
                    upstreamFragment={upstreamFragment}
                  />
                )
              )}
            </tbody>
          </table>
          <div>
            <AssemblyErrorsWarnings errors={errors} warnings={warnings} method={ASSEMBLY_TYPE.GOLDEN_GATE} />
          </div>
        </div>
      </div>
    </fieldset>
  );
}
